export const hasLogged = (key) => {
    return sessionStorage.getItem(key) === "1";
};

export const markLogged = (key) => {
    sessionStorage.setItem(key, "1");
};
